import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';

export const getEnv = createSelector(
  ({ env }: RootState) => env,
  env => env
);

export const getOrchestratorHost = createSelector(
  getEnv,
  ({ ORCHESTRATOR_HOST, ORCHESTRATOR_BACKEND_HOST }) =>
    __IS_SERVER__ ? ORCHESTRATOR_BACKEND_HOST : ORCHESTRATOR_HOST
);

export const getApiKey = createSelector(
  getEnv,
  ({ API_KEY, API_KEY_BACKEND }) =>
    __IS_SERVER__ ? API_KEY_BACKEND : API_KEY
);